import { Injectable } from '@angular/core';

import { ILazyLoader } from './lazy-interface-token';
import { LAZY_MODULES_MODULE, OTHER_MODULES } from './module.constants';

@Injectable({ providedIn: 'root' })
export class LazyComponentLoader implements ILazyLoader {
    lazyLoadedModule: string;
    private readonly LAZY_MODULES: string[] = LAZY_MODULES_MODULE;
    private readonly OTHER_MODULES: string[] = OTHER_MODULES;
    constructor() {}

    /* eslint-disable */
    getModule(lazyLoadedModule: string): Promise<any> {
        if (this.LAZY_MODULES.includes(lazyLoadedModule)) {
            return this.loadLazyModules(lazyLoadedModule);
        } else if (this.OTHER_MODULES.includes(lazyLoadedModule)) {
            return this.loadOtherModules(lazyLoadedModule);
        }
        // else if (this.CD_MODULES.includes(lazyLoadedModule)) {
        //     return this.loadCDModules(lazyLoadedModule);
        // }
        else {
            return Promise.reject('Not a known module!');
        }
    }

    /**
     * To Load Lazy Modules by Path
     * @param {string} module
     * @            returns {Promise<any}
     */
    private loadLazyModules(module: string): Promise<any> {
        switch (module) {
            case '@lazy-modules-module/racingFeatured/racing-featured.module':
                return import('@frontend/oxygen/core-racingfeatured').then((m) => m.RacingFeaturedModule);
            case '@lazy-modules-module/competitionsSportTab/competitionsSportTab.module':
                return import('@frontend/oxygen/core-competitionssporttab').then((m) => m.CompetitionsTabModule);
            case '@lazy-modules-module/forecastTricast/forecastTricast.module':
                return import('@frontend/oxygen/core-forecasttricast').then((m) => m.ForecastTricastModule);
            case '@lazy-modules-module/eventVideoStream/event-video-stream.module':
                return import('@frontend/oxygen/core-eventvideostream').then((m) => m.LazyEventVideoStreamModule);
            case '@lazy-modules-module/sortByOptions/sort-by-options.module':
                return import('@frontend/oxygen/core-sortbyoptions').then((m) => m.SortByOptionsModule);
            case '@lazy-modules-module/superButton/super-button.module':
                return import('@frontend/oxygen/core-superbutton').then((m) => m.SuperButtonModule);
            case '@lazy-modules-module/devLog/dev-log.module':
                return import('@frontend/oxygen/core-devlog').then((m) => m.DevLogModule);
            case '@lazy-modules-module/rpg/rpg.module':
                return import('@frontend/oxygen/core-rpg').then((m) => m.RpgModule);
            case '@lazy-modules-module/quiz/quiz-dialog.module':
                return import('@frontend/oxygen/core-quiz').then((m) => m.QuizDialogModule);
            case '@lazy-modules-module/lazy-initializer-homepage/lazy-initializer-homepage.module':
                return import('@frontend/oxygen/core-lazy-initializer-homepage').then((m) => m.LazyInitializerHomepageModule);
            case '@lazy-modules-module/receiptHeader/receipt-header.module':
                return import('@frontend/oxygen/core-receiptheader').then((m) => m.ReceiptHeaderModule);
            case '@lazy-modules-module/bpmpFreeTokens/bpmp-tokens.module':
                return import('@frontend/oxygen/core-bpmpfreebettokens').then((m) => m.BpmpFreeBetTokensModule);
            case '@lazy-modules-module/betpackOnboarding/betpack-onboarding.module':
                return import('@frontend/oxygen/core-betpackonboarding').then((m) => m.BetpackOnBoardingModule);
            case '@lazy-modules-module/betRadarProvider/bet-radar.module':
                return import('@frontend/oxygen/core-betradarprovider').then((m) => m.BetRadarCoralModule);
            case '@lazy-modules-module/runnerSpotlight/runner-spotlight.module':
                return import('@frontend/oxygen/core-runnerspotlight').then((m) => m.RunnerSpotlightModule);
            case '@lazy-modules-module/banners/banners.module':
                return import('@frontend/oxygen/core-banners').then((m) => m.BannersModule);
            case '@lazy-modules-module/market-description/market-description.module':
                return import('@frontend/oxygen/core-market-description').then((m) => m.MarketDescriptionModule);
            case '@lazy-modules-module/racingPostVerdict/racing-post-verdict.module':
                return import('@frontend/oxygen/core-racingpostverdict').then((m) => m.RacingPostVerdictModule);
            case '@lazy-modules-module/racingPostTip/racing-post-tip.module':
                return import('@frontend/oxygen/core-racingposttip').then((m) => m.RacingPostTipModule);
            case '@lazy-modules-module/nextRacesToBetslip/nextraces-to-betslip.module':
                return import('@frontend/oxygen/core-nextracestobetslip').then((m) => m.NextRacesToBetslipModule);
            case '@lazy-modules-module/competitionFilters/competitionFilters.module':
                return import('@frontend/oxygen/core-competitionfilters').then((m) => m.CompetitionFiltersModule);
            case '@lazy-modules-module/timeline/timeline.module':
                return import('@frontend/oxygen/core-timeline').then((m) => m.TimelineModule);
            case '@lazy-modules-module/racingMyBets/racing-mybets.module':
                return import('@frontend/oxygen/core-racingmybets').then((m) => m.RacingMybetsModule);
            case '@lazy-modules-module/maxpayOutErrorContainer/maxpayout-error-container.module':
                return import('@frontend/oxygen/core-maxpayouterrorcontainer').then((m) => m.MaxpayoutErrorContainerModule);
            case '@lazy-modules-module/listTemplate/list-template.module':
                return import('@frontend/oxygen/core-listtemplate').then((m) => m.ListTemplateModule);
            case '@lazy-modules-module/customFlagFiltertoggle/custom-flag-filter-toggle.module':
                return import('@frontend/oxygen/core-customflagfiltertoggle').then((m) => m.CustomFlagFilterToggleModule);
            case '@lazy-modules-module/multiMarketTemplate/multi-market-template.module':
                return import('@frontend/oxygen/core-multimarkettemplate').then((m) => m.MultiMarketTemplateModule);
            case '@lazy-modules-module/nextRaces/next-races.module':
                return import('@frontend/oxygen/core-nextraces').then((m) => m.NextRacesModule);
            case '@lazy-modules-module/freeRide/freeRide.module':
                return import('@frontend/oxygen/core-freeride').then((m) => m.FreeRideModule);
            case '@lazy-modules-module/floating-ihr-msg/floating-ihr-msg.module':
                return import('@frontend/oxygen/core-floating-ihr-msg').then((m) => m.FloatingIhrMsgModule);
            case '@lazy-modules-module/racingStatus/racing-status.module':
                return import('@frontend/oxygen/core-racingstatus').then((m) => m.RacingStatusModule);
            case '@lazy-modules-module/racesMeetingsOverlay/racing-meetings.module':
                return import('@frontend/oxygen/core-racesmeetingsoverlay').then((m) => m.RacingOverlayModule);
            case '@lazy-modules-module/fanzone/fanzone-shared.module':
                return import('@frontend/oxygen/core-lazyfanzone').then((m) => m.FanzoneSharedModule);
            case '@lazy-modules-module/couponsModule/coupons.module':
                return import('@frontend/oxygen/core-couponsmodule').then((m) => m.CouponsModule);
            case '@lazy-modules-module/raceCard/race-card-content.module':
                return import('@frontend/oxygen/core-racecard').then((m) => m.RaceCardContentModule);
            case '@lazy-modules-module/footerMenu/footer-menu.module':
                return import('@frontend/oxygen/core-footermenu').then((m) => m.FooterMenuModule);
            case '@lazy-modules-module/coupon-stat-widget/coupon-stat-widget.module':
                return import('@frontend/oxygen/core-coupon-stat-widget').then((m) => m.CouponStatWidgetModule);
            case '@lazy-modules-module/InplayHRHeader/inplay-hr-header.module':
                return import('@frontend/oxygen/core-inplayhrheader').then((m) => m.InplayHRHeaderModule);
            case '@lazy-modules-module/InPlaySportTab/in-play-sport-tab.module':
                return import('@frontend/oxygen/core-inplaysporttab').then((m) => m.InPlaySportTabModule);
            case '@lazy-modules-module/racingEventModel/racing-event-model.module':
                return import('@frontend/oxygen/core-racingeventmodel').then((m) => m.RacingEventModelModule);
            case '@lazy-modules-module/raceMarket/race-market.module':
                return import('@frontend/oxygen/core-racemarket').then((m) => m.RaceMarketModule);
            case '@lazy-modules-module/onBoardingTutorial/firstBetPlacement/first-bet-placement.module':
                return import('@frontend/oxygen/core-onboardingtutorial').then((m) => m.OnBoardingFirstBetModule);
            case '@lazy-modules-module/racingFullResults/racing-full-results.module':
                return import('@frontend/oxygen/core-racingfullresults').then((m) => m.RacingFullResultsModule);
            case '@lazy-modules-module/extraPlaceSignposting/extra-place-signposting.module':
                return import('@frontend/oxygen/core-extraplacesignposting').then((m) => m.ExtraPlaceSignpostingModule);
            case '@lazy-modules-module/raceCardInplay/race-card-inplay.module':
                return import('@frontend/oxygen/core-racecardinplay').then((m) => m.RaceCardInplayModule);
            case '@lazy-modules-module/twoUpSignpostingBlurbMsg/twoup-signposting-blurbmsg.module':
                return import('@frontend/oxygen/core-twoupsignpostingblurbmsg').then((m) => m.TwoUpSignPostingBlurbMsgModule);
            case '@lazy-modules-module/signposting/signposting.module':
                return import('@frontend/oxygen/core-signposting').then((m) => m.SignpostingModule);
            case '@lazy-modules-module/lazyNextRacesTab/lazyNextRacesTab.module':
                return import('@frontend/oxygen/core-lazynextracestab').then((m) => m.LazyNextRacesTabModule);
            case '@lazy-modules-module/bet-share-image-card/bet-share-image-card.module':
                return import('@frontend/oxygen/core-bet-share-image-card').then((m) => m.BetShareImageCardModule);
            case '@lazy-modules-module/lottoBetSlip/lotto-betslip.module':
                return import('@frontend/oxygen/core-lottobetslip').then((m) => m.LottoBetslipModule);
            case '@lazy-modules-module/statisticalContentInformation/statistical-content-information.module':
                return import('@frontend/oxygen/core-statisticalcontentinformation').then((m) => m.StatisticalContentInformationModule);
            case '@lazy-modules-module/luckyDip/luckyDip.module':
                return import('@frontend/oxygen/core-luckydip').then((m) => m.LuckyDipModule);
            case '@lazy-modules-module/stream-bet-tutorial-pop-up/stream-bet-tutorial-pop-up.module':
                return import('@frontend/oxygen/core-stream-bet-tutorial-pop-up').then((m) => m.StreamBetTutorialPopUpModule);
            case '@lazy-modules-module/eventQuickSwitch/quick-switch.module':
                return import('@frontend/oxygen/core-eventquickswitch').then((m) => m.LazyQuickSwitchModule);
            case '@lazy-modules-module/sidebar/sidebar.module':
                return import('@frontend/oxygen/core-sidebar').then((m) => m.SideBarModule);
            case '@lazy-modules-module/carouselMenu/carousel-menu.module':
                return import('@frontend/oxygen/core-carouselmenu').then((m) => m.CarouselMenuModule);
            case '@lazy-modules-module/quickLinks/quick-links.module':
                return import('@frontend/oxygen/core-quicklinks').then((m) => m.QuickLinksModule);
            case '@lazy-modules-module/promoLeaderboard/promo-leaderboard.module':
                return import('@frontend/oxygen/core-promoleaderboard').then((m) => m.PromoLeaderboardModule);
            case '@lazy-modules-module/home-screen/home-screen.module':
                return import('@frontend/oxygen/core-home-screen').then((m) => m.HomeScreenModule);
            case '@lazy-modules-module/myStableEdp/mystable-edp.module':
                return import('@frontend/oxygen/core-mystableedp').then((m) => m.myStableEdpModule);
            case '@lazy-modules-module/myStableCarousel/mystable-carousel.module':
                return import('@frontend/oxygen/core-mystablecarousel').then((m) => m.MystableCarouselModule);
            case '@lazy-modules-module/myStableRacingModule/mystable-racing.module':
                return import('@frontend/oxygen/core-mystableracingmodule').then((m) => m.myStableRacingModule);
            case '@lazy-modules-module/racingLazy/racing-lazy.module':
                return import('@frontend/oxygen/core-racinglazy').then((m) => m.RacingLazyModule);
            case '@lazy-modules-module/profit-indicator/profit-indicator.module':
                return import('@frontend/oxygen/core-profit-indicator').then((m) => m.ProfitIndicatorModule);
            case '@lazy-modules-module/betslipBar/betslip-bar.module':
                return import('@frontend/oxygen/core-betslipbar').then((m) => m.BetslipBarModule);
            case '@lazy-modules-module/insightsTab/insights.module':
                return import('@frontend/oxygen/core-insightstab').then((m) => m.InsightsModule);
            case '@lazy-modules-module/trending-bets-carousel/trending-bets-carousel.module':
                return import('@frontend/oxygen/core-trending-bets-carousel').then((m) => m.TrendingBetsCarouselModule);
            case '@lazy-modules-module/fzPopularBets/fz-popular-bets.module':
                return import('@frontend/oxygen/core-fzpopularbets').then((m) => m.FzPopularBetsModule);
            case '@lazy-modules-module/virtualNextEvents/virtual-next-events.module':
                return import('@frontend/oxygen/core-virtualnextevents').then((m) => m.VirtualNextEventsModule);
            case '@lazy-modules-module/mystable-crc-racealert-onboarding/mystable-crc-racealert.module':
                return import('@frontend/oxygen/core-mystable-crc-racealert-onboarding').then((m) => m.myStableCrcRaceAlertOnboardingModule);
            case '@lazy-modules-module/popularBetsModule/popular-bets.module':
                return import('@frontend/oxygen/core-popularbetsmodule').then((m) => m.PopularBetsModule);
            case '@lazy-modules-module/more-link/more-link.module':
                return import('@frontend/oxygen/core-more-link').then((m) => m.MoreLinkModule);
            case '@lazy-modules-module/bybWidget/featured-byb-widget.module':
                return import('@frontend/oxygen/core-bybwidget').then((m) => m.FeaturedBybWidgetModule);
            case '@lazy-modules-module/oddsCardStatsModule/odds-card-stats.module':
                return import('@frontend/oxygen/core-oddscardstatsmodule').then((m) => m.OddsCardStatsModule);
            case '@lazy-modules-module/betFilters/bet-filters.module':
                return import('@frontend/oxygen/core-betfilters').then((m) => m.BetFiltersModule);
            case '@lazy-modules-module/inplay-stat-widget/inplay-stat-widget.module':
                return import('@frontend/oxygen/core-inplay-stat-widget').then((m) => m.InplayStatWidgetModule);
            case '@lazy-modules-module/bybLabel/byb-label.module':
                return import('@frontend/oxygen/core-byblabel').then((m) => m.BybLabelModule);
            case '@lazy-modules-module/luckyDip/lucky-dip-lazy.module':
                return import('@frontend/oxygen/core-luckydip').then((m) => m.LuckyDipLazyModule);
            case '@lazy-modules-module/odds-boost-msg/odds-boost-msg.module':
                return import('@frontend/oxygen/core-odds-boost-msg').then((m) => m.OddsBoostMsgModule);
            case '@lazy-modules-module/scoreCard/score-card.module':
                return import('@frontend/oxygen/core-scorecard').then((m) => m.ScoreCardModule);
            case '@lazy-modules-module/oddsCardInplayLazy/odds-card-inplay-lazy.module':
                return import('@frontend/oxygen/core-oddscardinplaylazy').then((m) => m.OddsCardInPlayLazyModule);
            case '@lazy-modules-module/historicPricesLazy/historic-prices-lazy.module':
                return import('@frontend/oxygen/core-historicpriceslazy').then((m) => m.HistoricPricesLazyModule);
            case '@lazy-modules-module/inplayScoreLazy/inplay-score-lazy.module':
                return import('@frontend/oxygen/core-inplayscorelazy').then((m) => m.InplayScoreLazyModule);
            case '@lazy-modules-module/crestImage/crest-image.module':
                return import('@frontend/oxygen/core-crestimage').then((m) => m.CrestImageModule);
            case '@lazy-modules-module/oddsCardSpecialsLazy/odds-card-specials-lazy.module':
                return import('@frontend/oxygen/core-oddscardspecialslazy').then((m) => m.OddsCardSpecialsLazyModule);
            case '@lazy-modules-module/priceBoostModule/price-boost.module':
                return import('@frontend/oxygen/core-priceboostmodule').then((m) => m.PriceBoostModule);
            case '@lazy-modules-module/edpPriceBoostModule/edp-price-boost.module':
                return import('@frontend/oxygen/core-edppriceboostmodule').then((m) => m.EDPPriceBoostModule);
            case '@lazy-modules-module/singlePriceBoostModule/single-price-boost.module':
                return import('@frontend/oxygen/core-singlepriceboostmodule').then((m) => m.SinglePriceBoostModule);
            case '@lazy-modules-module/quaccabar/quaccabar.module':
                return import('@frontend/oxygen/core-quaccabar').then((m) => m.QuaccabarModule);
            default:
                return Promise.reject(new Error('Module not found'));
        }
    }

    /**
     * To Load Other Modules
     * @param {string} module
     * @            returns {Promise<any>}
     */
    private loadOtherModules(module: string): Promise<any> {
        switch (module) {
            case '@lazy-modules/locale/translation.module':
                return import('@frontend/oxygen/core-locale').then((m) => m.TranslationModule);
            case '@lazy-modules/flagSource/flag-source.module':
                return import('@frontend/oxygen/core-flagsource').then((m) => m.FlagSourceModule);
            case '@app/stats/stats.module':
                return import('@frontend/oxygen/core-stats').then((m) => m.StatsModule);
            case '@uktote-lazy-load/uk-tote.module':
                return import('@frontend/oxygen/core-uktote').then((m) => m.UkToteModule);
            case '@lazy-modules/gamingOverlay/gaming-overlay.module':
                return import('@frontend/oxygen/core-gamingoverlay').then((m) => m.GamingOverlayModule);
            case '@yourCallModule/your-call.module':
                return import('@frontend/oxygen/core-yourcall').then((m) => m.YourCallModule);
            case '@oddsBoostModule/odds-boost.module':
                return import('@frontend/oxygen/core-oddsboost').then((m) => m.OddsBoostModule);
            case '@racingModule/racing.module':
                return import('@frontend/oxygen/core-racing').then((m) => m.RacingModule);
            case '@retail-lazy-load/retail.module':
                return import('@frontend/oxygen/core-retail').then((m) => m.RetailModule);
            case '@betHistoryModule/bet-history.module':
                return import('@frontend/oxygen/core-bethistory').then((m) => m.BetHistoryModule);
            case '@featuredModule/featured.module':
                return import('@frontend/oxygen/core-featured').then((m) => m.FeaturedModule);
            case '@toteModule/tote.module':
                return import('@frontend/oxygen/core-tote').then((m) => m.ToteModule);
            case '@betslipModule/betslip.module':
                return import('@frontend/oxygen/core-betslip').then((m) => m.BetslipModule);
            case '@quickbetModule/quickbet.module':
                return import('@frontend/oxygen/core-quickbet').then((m) => m.QuickbetModule);
            case '@quickbetStreamBetModule/sb-quickbet.module':
                return import('@frontend/oxygen/core-quickbet-stream-bet').then((m) => m.StreamBetQuickbetModule);
            case '@edpModule/edp.module':
                return import('@frontend/oxygen/core-edp').then((m) => m.EdpModule);
            case '@inplayModule/inplay.module':
                return import('@frontend/oxygen/core-inplay').then((m) => m.InplayModule);
            case '@freebetsModule/freebets.module':
                return import('@frontend/oxygen/core-freebets').then((m) => m.FreebetsModule);
            case '@quickDepositModule/quick-deposit.module':
                return import('@frontend/oxygen/core-quickdeposit').then((m) => m.QuickDepositModule);
            case '@lazy-modules/seoStaticBlock/seo-static-block.module':
                return import('@frontend/oxygen/core-seostaticblock').then((m) => m.SeoStaticBlockModule);
            case '@sharedModule/components/marketSelector/market-selector.module':
                return import('@frontend/oxygen/core-marketselector').then((m) => m.MarketSelectorModule);
            case '@bybHistoryModule/byb-history.module':
                return import('@frontend/oxygen/core-lazybybhistory').then((m) => m.LazyBybHistoryModule);
            case '@rightColumnModule/right-column.module':
                return import('@frontend/oxygen/core-rightcolumn').then((m) => m.RightColumnModule);
            case '@specialsModule/specials-sport-tab.module':
                return import('@frontend/oxygen/core-specialssporttab').then((m) => m.SpecialsSportTabModule);
            case '@sharedModule/components/oddsCard/oddsCardHightlightCarousel/odds-card-highligt-carousel.module':
                return import('@frontend/oxygen/core-oddscardhighlight').then((m) => m.OddsCardHighlightCarouselModule);
            case '@lazy-modules-module/lazyPromotionIcons/lazy-promotion-icons.module':
                return import('@frontend/oxygen/core-lazypromotionicons').then((m) => m.LazyPromotionIconsModule);
            case '@lazy-modules-module/casinoMyBetsIntegration/casino-my-bets-integration.module':
                return import('@frontend/oxygen/core-casinomybetsintegration').then((m) => m.CasinoMyBetsIntegrationModule);
            case '@betpackModule/betpack-market.module':
                return import('@frontend/oxygen/core-betpackmarket').then((m) => m.BetpackMarketModule);
            case '@lazy-modules/networkIndicator/network-indicator.module':
                return import('@frontend/oxygen/core-networkindicator').then((m) => m.NetworkIndicatorModule);
            case '@sharedModule/components/moduleRibbon/module-ribbon.module':
                return import('@frontend/oxygen/core-moduleribbon').then((m) => m.RibbonModule);
            case '@inPlayLiveStream/inplay-live-stream.module':
                return import('@frontend/oxygen/core-inplaylivestream').then((m) => m.InplayLiveStreamModule);
            case '@sharedModule/components/liveClock/live-clock.module':
                return import('@frontend/oxygen/core-liveclock').then((m) => m.LiveClockModule);
            default:
                return Promise.reject(new Error('Module not found'));
        }
    }
}
